// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___Nazm0","root__item":"style-module__root__item___ojpFZ","root__item__active":"style-module__root__item__active___SmK72"};
    if(module.hot) {
      // 1697460476171
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  